(() => {
  const selector =
    '.template-collection .facets--horizontal .facets__inputs-wrapper';
  const initialized = new WeakSet();

  const isChoiceFilter = (scroller) =>
    Boolean(
      scroller.querySelector(
        'input[type="checkbox"], input[type="radio"]'
      )
    );

  const updateScroller = (scroller) => {
    if (!(scroller instanceof HTMLElement)) return;

    const enabled = isChoiceFilter(scroller);
    scroller.classList.toggle('pg-facet-scroll-enabled', enabled);

    if (!enabled) {
      scroller.classList.remove('pg-facet-scrollable', 'pg-facet-has-more');
      return;
    }

    const maxScroll = scroller.scrollHeight - scroller.clientHeight;
    const canScroll = maxScroll > 4;
    const hasMoreBelow = canScroll && scroller.scrollTop < maxScroll - 4;

    scroller.classList.toggle('pg-facet-scrollable', canScroll);
    scroller.classList.toggle('pg-facet-has-more', hasMoreBelow);
  };

  const initScroller = (scroller) => {
    if (!(scroller instanceof HTMLElement)) return;

    if (!initialized.has(scroller)) {
      initialized.add(scroller);
      scroller.addEventListener('scroll', () => updateScroller(scroller), {
        passive: true,
      });
    }

    requestAnimationFrame(() => updateScroller(scroller));
  };

  const enhance = (root = document) => {
    if (root instanceof Element && root.matches(selector)) {
      initScroller(root);
    }

    root.querySelectorAll?.(selector).forEach(initScroller);
  };

  const refreshAll = () => {
    document.querySelectorAll(selector).forEach(updateScroller);
  };

  const boot = () => {
    enhance(document);

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => updateScroller(entry.target));
      });

      document.querySelectorAll(selector).forEach((scroller) =>
        resizeObserver.observe(scroller)
      );

      const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;

            enhance(node);

            if (node.matches?.(selector)) {
              resizeObserver.observe(node);
            }

            node.querySelectorAll?.(selector).forEach((scroller) =>
              resizeObserver.observe(scroller)
            );
          });
        });

        requestAnimationFrame(refreshAll);
      });

      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    } else {
      const mutationObserver = new MutationObserver(() => {
        enhance(document);
        requestAnimationFrame(refreshAll);
      });

      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    document.addEventListener(
      'toggle',
      () => requestAnimationFrame(refreshAll),
      true
    );

    window.addEventListener(
      'resize',
      () => requestAnimationFrame(refreshAll),
      { passive: true }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
